export default __webpack_public_path__ + "static/media/tabs-image-01.27a9e791.jpg";